import Vue from 'vue'
import Element from 'element-ui'
// eslint-disable-next-line import/no-extraneous-dependencies
import AFTableColumn from 'af-table-column'
import App from './App'

// 全局方法
import router from './router'
import store from './store'
import { resetForm } from './utils'

// 全局声明
// import UploadImage from './components/upload/image'

// 全局样式
import 'normalize.css'
import './styles/index.scss'
import './styles/variables.scss'
import 'common-css-myself'

import './icons'
import './permission'

// 挂载过滤器
import * as filters from './filters'
import useComponents from './components'

Vue.use(useComponents)
Vue.use(AFTableColumn)
// Vue.component('upload-image', UploadImage)
Vue.prototype.$resetForm = resetForm

Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]))

Vue.use(Element)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
